module.exports = __webpack_public_path__ + "static/img/y_zhxt62.29276cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y_zhxt62.png
// module id = vt8v
// module chunks = 73